export enum GroupingFilterType {
  And = 'And',
  Or = 'Or',
}
